export default class Wishes {
    filterParams() {
        return {
            params: {
                search: "",
                date: [],
                users: [],
                categories: [],
                is_moderate: null,
                themes: [],
                wishlists: [],
            },
            enable: true,
        }
    }
}
